export enum AdvisoryPurchaseModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
